"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeAlert = exports.serializeAlert = exports.deserializeAlertNotification = exports.serializeAlertNotification = exports.deserializeComment = exports.serializeComment = exports.deserializeAcknowledged = exports.serializeAcknowledged = exports.deserializeAlertState = exports.serializeAlertState = void 0;
const moment_1 = __importDefault(require("moment"));
const entities_1 = require("../entities");
const serializeAlertState = (state) => state.toString();
exports.serializeAlertState = serializeAlertState;
const deserializeAlertState = (stateSerialized) => {
    switch (stateSerialized) {
        case 'NORMAL':
            return entities_1.AlertState.NORMAL;
        case 'OFF_NORMAL':
            return entities_1.AlertState.OFF_NORMAL;
        case 'ACKNOWLEDGED':
            return entities_1.AlertState.ACKNOWLEDGED;
        default:
            throw new Error(`Unknown serialized AlertState: ${stateSerialized}`);
    }
};
exports.deserializeAlertState = deserializeAlertState;
const serializeAcknowledged = (acknowledged) => ({
    ...acknowledged,
    createdAt: acknowledged.createdAt.toISOString(),
});
exports.serializeAcknowledged = serializeAcknowledged;
const deserializeAcknowledged = (acknowledgedSerialized) => {
    return {
        ...acknowledgedSerialized,
        createdAt: moment_1.default(acknowledgedSerialized.createdAt).toDate(),
    };
};
exports.deserializeAcknowledged = deserializeAcknowledged;
const serializeComment = (comment) => ({
    ...comment,
    createdAt: comment.createdAt.toISOString(),
});
exports.serializeComment = serializeComment;
const deserializeComment = (commentSerialized) => ({
    ...commentSerialized,
    createdAt: moment_1.default(commentSerialized.createdAt).toDate(),
});
exports.deserializeComment = deserializeComment;
const serializeAlertNotification = (alertNotification) => ({
    ...alertNotification,
    createdAt: alertNotification.createdAt.toISOString(),
    state: exports.serializeAlertState(alertNotification.state),
    acknowledged: exports.serializeAcknowledged(alertNotification.acknowledged),
    comments: alertNotification.comments.map(exports.serializeComment),
});
exports.serializeAlertNotification = serializeAlertNotification;
const deserializeAlertNotification = (alertNotificationSerialized) => ({
    ...alertNotificationSerialized,
    createdAt: moment_1.default(alertNotificationSerialized.createdAt).toDate(),
    state: exports.deserializeAlertState(alertNotificationSerialized.state),
    // acknowledged: alertNotificationSerialized.acknowledged.map((a) => ({
    //   ...a,
    //   created: moment(a.created).toDate(),
    // })),
    comments: alertNotificationSerialized.comments.map((c) => ({
        ...c,
        createdAt: moment_1.default(c.created).toDate(),
    })),
});
exports.deserializeAlertNotification = deserializeAlertNotification;
const serializeAlert = (alert) => ({
    ...alert,
    state: exports.serializeAlertState(alert.state),
    lastNotification: exports.serializeAlertNotification(alert.lastNotification),
    updatedAt: alert.updatedAt.toISOString(),
});
exports.serializeAlert = serializeAlert;
const deserializeAlert = (alertSerialized) => ({
    ...alertSerialized,
    state: exports.deserializeAlertState(alertSerialized.state),
    lastNotification: exports.deserializeAlertNotification(alertSerialized.lastNotification),
    updatedAt: moment_1.default(alertSerialized.updatedAt).toDate(),
});
exports.deserializeAlert = deserializeAlert;
//# sourceMappingURL=serdes.js.map